import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';

// This carousel is used on the 'Coffee' page, alongside the section (coffee-feature.liquid) and card snippet (coffee-feature-card.liquid).
// There are a TON of breakpoints used, but it's to keep the cards looking decent at each interval.
// The navigation is unused, but seems to be necessary for the carousel to initialize.

const selectors = {
    carouselWrapper: '[data-coffee-carousel]',
};

class CoffeeCarousel extends HTMLElement {
    constructor() {
        super();

        document.addEventListener('DOMContentLoaded', () => {
            this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);
            this.render();
        });
    };

    // Initialize the carousel on load.
    render() {
        this.initCarousels();

        // On resize, check if we need a Swiper object, checking the breakpoint.
        // If not, the carousel will be destroyed.
        this.registerEventListeners();
    };

    initCarousels() {
        this.carousel = new Swiper(selectors.carouselWrapper, {
            modules: [Navigation, Scrollbar],
            lazy: true,
            lazyPreloadPrevNext: 2,
            slidesPerView: 1.1,
            spaceBetween: 6,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.slider-scrollbar',
                draggable: true,
                hide: false,
                snapOnRelease: false,
                dragSize: 40,
            },
            breakpoints: {
                480: {
                    slidesPerView: 1.2,
                    scrollbar: {
                        dragSize: 140,
                    },
                },
                580: {
                    slidesPerView: 1.4,
                    scrollbar: {
                        dragSize: 140,
                    },
                },
                680: {
                    slidesPerView: 1.6,
                    scrollbar: {
                        dragSize: 140,
                    },
                },
                780: {
                    slidesPerView: 1.8,
                    scrollbar: {
                        dragSize: 140,
                    },
                },
                880: {
                    slidesPerView: 1.9,
                    scrollbar: {
                        dragSize: 140,
                    },
                },
                980: {
                    slidesPerView: 2.1,
                    scrollbar: {
                        dragSize: 140,
                    },
                },
            },
        });
    };

    registerEventListeners() {
        window.addEventListener('resize', () => {
            this.carousel.update();
        });
    };
};

customElements.define('coffee-carousel', CoffeeCarousel);